import { get } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchCoursesList = (): Promise<AxiosResponse> =>
  get('/courses/courses')
